import React, { useCallback, useEffect, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';

import {
  doc,
  updateDoc,
  arrayUnion,
  addDoc,
  collection,
} from 'firebase/firestore';
import { logEvent } from 'firebase/analytics';

import { FirebaseContext } from '../firebase/FirebaseContext';
import {
  Name,
  Phone,
  Email,
  CheckInCheckOut,
  Adults,
  Rooms,
  Children,
} from '../components/form/Inputs';

import './Form.css';

export const Form: React.FC<any> = ({}) => {
  const [checkin, setCheckin] = React.useState<Date | null>(null);
  const [checkout, setCheckout] = React.useState<Date | null>(null);
  const [adults, setAdults] = React.useState<number>(1);
  const [children, setChildren] = React.useState<number>(0);
  const [rooms, setRooms] = React.useState<number>(1);

  const { db, analytics } = useContext(FirebaseContext);
  const { account, property } = useParams();

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const callback = () => {
      logEvent(analytics, 'naviagte_to_join_waitlist', {
        accountId: account,
      });
    };
    window.addEventListener('load', callback);
    return () => window.removeEventListener('load', callback);
  }, []);

  const handleAddToWaitlist = useCallback(
    async (e: any) => {
      e.preventDefault();
      e.stopPropagation();

      const form = new FormData(e.target);
      // TODO: validation

      const payload = {
        id: uuid(),
        name: form.get('name'),
        phone: form.get('phone'),
        email: form.get('email'),
        adults,
        children,
        rooms,
        checkin,
        checkout,
      };

      if (!account) {
        return;
      }
      try {
        const defaultDocRef = doc(
          db,
          'users',
          account,
          'properties',
          'default'
        );

        const unionRes = await updateDoc(defaultDocRef, {
          waitlist: arrayUnion(payload),
        });

        console.log('Res of add', unionRes);

        // Send email/sms
        const msg = collection(db, 'messages');
        await addDoc(msg, {
          to: form.get('phone'),
          body:
            "You've successfully been added to the waitlist. You'll be notified when availablity is found matching your criterias.",
        });

        const emails = collection(db, 'mail');
        await addDoc(emails, {
          to: form.get('email'),
          message: {
            subject: "You've joined the waitlist!",
            text: `Hi ${form.get(
              'name'
            )},\n\nYou've successfully been added to the waitlist. You'll be notified when availablity is found matching your criterias.\n\nRezylist team`,
          },
        });

        setSubmitted(true);
        logEvent(analytics, 'joined_waitlist', {
          accountId: account,
          propertyId: property,
        });
      } catch (e) {
        console.error('Error adding document: ', e);
        logEvent(analytics, 'failed_to_join_waitlist', {
          error: (e as any).message as string,
        });
      }
    },
    [checkin, checkout, adults, children, rooms, account, property]
  );

  return (
    <>
      <Card
        style={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          flexDirection: 'column',
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            width: '100%',
            background: 'black',
            height: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src="../../assets/iroquois.svg" height={150} width={150} />
        </div>
        {submitted && (
          <Typography style={{ maxWidth: 600, padding: '50px' }}>
            Success! You've successfully been added to The Iroquois New York
            Reservation Waiting List. You'll be notified when availability is
            found matching your reservation criteria.
          </Typography>
        )}
        {!submitted && (
          <form
            onSubmit={handleAddToWaitlist}
            style={{ maxWidth: 600, padding: '50px' }}
          >
            <Typography textAlign="left">
              Welcome to the Exclusive Reservation Waiting List of The Iroquois
              New York. If your selected reservation becomes available you will
              be notified immediately through our RezyList system.
            </Typography>
            <Typography textAlign="left" margin="20px 0">
              Please enter in your information below.
            </Typography>
            <DialogContent>
              <Name />
              <Phone />
              <Email />
              <div>
                <CheckInCheckOut
                  setCheckin={setCheckin}
                  checkin={checkin}
                  setCheckout={setCheckout}
                  checkout={checkout}
                />
              </div>
              <Adults adults={adults} setAdults={setAdults} />
              <Rooms rooms={rooms} setRooms={setRooms} />
              <Children children={children} setChildren={setChildren} />
            </DialogContent>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 75,
              }}
            >
              <Button type="submit" variant="contained">
                Join Waitlist
              </Button>
            </div>
          </form>
        )}
        <footer
          style={{
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: ' 100%',
            padding: 20,
            background: 'black',
            color: 'white',
          }}
        >
          <Typography>@2022 All right reserved.</Typography>
        </footer>
      </Card>
    </>
  );
};
